import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../../core/auth/auth.service';
import { UserService } from '../../../../core/user.service';
import * as Chart from "chart.js";

@Component({
  selector: 'app-cqmns-failed-functionality',
  templateUrl: './cqmns-failed-functionality.component.html',
  styleUrls: ['./cqmns-failed-functionality.component.css']
})
export class CqmnsFailedFunctionalityComponent implements OnInit {

  canvas: any;
    ctx: any;
    myTrendFailed: any;
    classificationsFailed = [];
    noOfclassificationsFailed = [];
    results: any;
    userId:any;
    userid:any;
    classes: any;
    headers = new HttpHeaders();
    hostUrl;
    fromDate = this.addMonths(new Date(), -6).toISOString().substring(0,10)+' 00:00:00';
    toDate = new Date().toISOString().substring(0,10)+' 23:59:59';
    projectId:any;
      colors = [
      "rgb(93, 98, 181)",
      "rgb(105, 213, 209)",
     "rgb(0, 109, 144)",
     "rgb(195, 88, 172)"];
  
    projects: any;
    res1: any;
    res2:any;
  constructor(private http: HttpClient, private route: ActivatedRoute, private authService: AuthService, private userService: UserService) {

   }

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.userId = localStorage.getItem('userid'); 
    this.hostUrl=this.userService.getUrl();
    //this.projectId = this.route.snapshot.params["projectId"];
    this.projectId = localStorage.getItem("projectId");
    this.http.get(encodeURI(this.hostUrl+'/api/issue/countByFailedFunctionality/' + this.projectId))
     .subscribe( data1 => {
       console.log(data1)
       this.res1 = data1
         for (const k in this.res1) {
             if (k !== 'null') {
                 this.classificationsFailed.push(k);
             }
         }
    this.http.get(encodeURI(this.hostUrl+'/api/issue/countByVersion/' + this.projectId))
                 .subscribe( data2 => {
             this.results = data2
             console.log(this.results);
             
             this.updateChart(this.myTrendFailed);           
        });            
     });
    
     this.headers = this.headers.append('Content-Type', 'application/json');
     const updateBody = {'from': this.fromDate, 'to' : this.toDate };
  }

  addUser(data){
    this.userId = data.user_id;
  }

  ngAfterViewInit() {

    Chart.defaults.global.defaultFontColor = '#000';
  this.canvas = document.getElementById('myTrendFailed');
  this.ctx = this.canvas.getContext('2d');
  this.myTrendFailed = new Chart(this.ctx, {
    type: 'bar',
    data: {
     // labels: this.projectId,
      datasets: [
      ]
    },
    options:  {
      responsive: false,
      legend: {
         position: 'top' // place legend on the right side of chart
      },
      scales: {
         xAxes: [{
            stacked: true, // this should be set to make the bars stacked
            barPercentage: 0.2
         }],
         yAxes: [{
            stacked: true // this also..
         }]
      }
   }
  });
  
  }

  updateChart(myTrendFailed) {
    this.myTrendFailed.data.datasets = [];
    this.myTrendFailed.data.labels = [];
    myTrendFailed.update();
    for (let i = 0; i < this.classificationsFailed.length; i++) {
        myTrendFailed.data.datasets.push({
            label: this.classificationsFailed[i],
            data: new Array(this.results.length).fill(0),
            backgroundColor: this.getColor(i)
        });
    }
    myTrendFailed.update();
    if(this.results !== undefined) {
        for (let i = 0; i < this.results.length; i++) {
               //this.releaseversion.push(this.results[i].release_version)
              //  this.projectId.push(this.results[i].release_version)
                myTrendFailed.data.labels.push(this.results[i].release_version)
                this.hostUrl = this.userService.getUrl();
                this.projectId = this.route.snapshot.params["projectId"];
              //  this.http.get(encodeURI(this.hostUrl+'/api/issue/countByFailedVsReleaseVersion/' + this.projectId))
               //  .subscribe( data => {
                     //console.log(data);
                  //    let data = [{"failed_fuctn":"WIFI","count(*)":1}]
                  //    for (const j in data) {
                  //     for (let k = 0; k < this.myTrendFailed.data.datasets.length; k++) {
                  //         if (data[j].failed_fuctn === this.myTrendFailed.data.datasets[k].label) {
                  //             myTrendFailed.data.datasets[k].data[i] += data[j]['count(*)'];
                  //             myTrendFailed.update();
                  //             break;
                  //         }
                  //     }
                  // }
               // });
               this.http.get(encodeURI(this.hostUrl+'/api/issue/countByFailedVsReleaseVersion/' + this.projectId + '/' + this.results[i].release_version))
                   .subscribe( data => {
                     console.log(data);
                     for (const j in data) {
                      for (let k = 0; k < this.myTrendFailed.data.datasets.length; k++) {
                          if (data[j].failed_fuctn === this.myTrendFailed.data.datasets[k].label) {
                              myTrendFailed.data.datasets[k].data[i] += data[j]['count(*)'];
                              myTrendFailed.update();
                              break;
                          }
                      }
                  }
                  });    

        }
        myTrendFailed.update();
    }   
}

  rotate(arr, n){
    for(let i=0;i<n;i++){
        let swap = arr[0];
        for(let j=0;j<arr.length-1;j++){
            arr[j] = arr[j+1];
        }
        arr[arr.length - 1] = swap;
    }
}

  getColor(num){
    if(num < 9){
        return this.colors[num];
    }else{
        this.getRandomColor();
    }
}

getRandomColor() {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

  addMonths(date, months) {
    date.setMonth(date.getMonth() + months);
    return date;
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-defect/cqmns-failed-functionality/cqmns-failed-functionality.component.ts